<template>
  <div style="display:flex;height:100%">
    <!-- 好友列表 -->
    <list
      ref="list"
      :user-list="userList"
      :session="session"
      :session-index.sync="sessionIndex"
      :search="search"
      @isRead="$emit('isRead')"
      @emptyShow="$emit('emptyShow')"
    ></list>
    <div style="flex:1;background-color:#fefefe;height: 100%;">
      <div style="border-bottom: 1px solid rgb(204, 204, 204);display: flex;justify-content: space-between;">
        <div class="message-head" style="padding: 21.5px 21px;box-sizing: border-box;flex: 3;">
          <span v-if="isFriend && !isemptyShow">{{userList.length>0 ? !isFriend ? ' ' : userList.filter(item => item.id === session.userId)[0].name : ' '}}</span>
          <span v-else>&nbsp;</span>
        </div>
        <span style="flex: 1;display: flex;justify-content: space-around;align-items: center;user-select: none;">
          <img style="cursor: pointer;" :src="require('@/assets/images/mini.png')" alt="最小化" @click.stop="closeDialog">
          <img style="cursor: pointer;" :src="require('@/assets/images/react.png')"  @click="$emit('toggleFullScreen')">
          <img style="cursor: pointer;" :src="require('@/assets/images/close.png')" alt="关闭" @click.stop="closeDialog">
        </span>
      </div>
      <!-- 消息展示 -->
      <message :session="session" :user="user" :user-list="userList" v-show='isFriend && !isemptyShow' ref="messagedom"></message>
      <!-- 发送消息框 -->
      <texts 
        v-show='isFriend && !isemptyShow'
        :user-list="userList" 
        :session="session" 
        :isemptyShow="isemptyShow"
        :user="user" 
        ref="texts" 
        @hasNewFriend="$emit('hasNewFriend')" 
        @updateMsg="(data)=>{$emit('updateMsg',data)}" 
        @changebadge="(value)=>{$emit('changebadge',value);$refs.messagedom.clickActive = null}"
        @updatebadge="$emit('updatebadge')"
        @chatVideo="chatVideo"></texts>
      <div v-if="showMemo ? false : (isemptyShow && isFriend)?isemptyShow:(!isFriend && !showFriendsList)" class="emptyTemp">
        <img :src="require('@/assets/images/logo.png')" alt="">
      </div>
    </div>
    <videoComponent ref="videoComponent" @videoCallback="videoCallback" :chatid="chatid"></videoComponent>
  </div>
</template>

<script>
// 好友列表
import list from "./list";
// 发送消息框
import texts from "./texts";
// 消息展示
import message from './message';
// 视频聊天
import videoComponent from './video/video';
let vm = {};
export default {
  props: ["userList", "sessionIndex", "session", "search", "choose", "user","isemptyShow","isFriend","showFriendsList","showMemo"],
  components: {
    texts,
    list,
    message,
    videoComponent
  },
  data() {
    vm = this;
    return {
      chatid: ""
    };
  },
  methods: {
    // 视频聊天的callback
    videoCallback(){
      
      this.chatid = "";// props 是单向数据传递 这里加回调清空，保证下次传递的id有值
    },
    // 视频聊天
    chatVideo(id){
      
      this.chatid = "";
      setTimeout(() => {
        this.chatid = id;
      },10)
    },
    /*
     *@Author: 王伟东
     *@Date: 2021-09-27 19:37:14
     *@Description: 关闭聊天
     *@params: 
    */
    closeDialog(){
      if (this.jquery(".videoBoxContener").css("display") != "none") {
        this.$refs.videoComponent.cancle();
      }
      this.$emit('close');
    }
  },
};
</script>

<style lang="scss" scoped>
.emptyTemp{
  height: 89%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/vueChart/ChatSession.vue